import React from "react";
import { StyledFooterWrapper } from "./styled";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getMerchantConfig } from "features/config/configSlice";
import { useTranslation } from "react-i18next";

function Footer() {
  const location = useLocation();
  const merchantConfig = useSelector(getMerchantConfig);
  const { t } = useTranslation();
  return (
    <StyledFooterWrapper
      location={location.pathname}
      className="rms-footer-wrapper"
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent:
            location.pathname !== "/" && location.pathname !== "/returns"
              ? "space-between"
              : "center",
          background: "#fff",
          paddingLeft: "0px",
          margin: "0px",
          alignItems: 'center'
        }}
      >
        {merchantConfig.whatsapp_help &&
          merchantConfig.whatsapp_help !== null &&
          location.pathname !== "/" &&
          location.pathname !== "/returns" && (
            <a
              href={merchantConfig.whatsapp_help}
              target="_blank"
              rel="noreferrer"
              className="help"
              style={{
                fontWeight: "700",
                fontSize: "13px",
                color: "var(--rms-v2-text-title)",
                textDecoration: "underline",
                display: "block",
              }}
            >
              {t("footer.needHelp")}
            </a>
          )}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            whiteSpace: "nowrap",
            width: "max-content",
            fontSize: "13px",
          }}
        >
          {t("footer.poweredBy")}
          <div>
            <a
              href="https://bepragma.ai/?utm_source=RMS&utm_medium=entrypage&utm_campaign=footer"
              target="_blank"
              rel="noreferrer"
              style={{ marginLeft: "5px" }}
            >
              {(location.pathname === "/" ||
                location.pathname === "/returns") &&
              merchantConfig?.public_page_theme_configurations
                ?.cover_image_width === 100 ? (
                <img
                  src="https://pragma-static-duke.s3.amazonaws.com/static/metronic/assets/media/logos/pragma-default-dark.svg"
                  alt="PRAGMA."
                />
              ) : (
                <img
                  src="https://pragma-staticfiles-prod.s3.amazonaws.com/static/metronic/assets/media/logos/pragma-default-light.svg"
                  alt="PRAGMA."
                />
              )}
            </a>
          </div>
        </div>
      </div>
    </StyledFooterWrapper>
  );
}

export default Footer;
